import * as React from "react";
import { TextFieldLabel } from "../core/TextField";
import Select from "react-select";
import { findCompany } from "../../libs/chartec_cw";
import { debounce } from "lodash";

interface IProps {
  onSelect: (opt: ISelectOption<ICtCompanySearchResult> | null) => void;
}

interface IState {
  companyResults: ICtCompanySearchResult[];
  searchingCompanies: boolean;
  selectedOption?: ISelectOption<ICtCompanySearchResult>;
}

class PickCwCompany extends React.Component<IProps, IState> {
  state: Readonly<IState> = { companyResults: [], searchingCompanies: false };

  doCompanySearch = debounce(async query => {
    const result = await findCompany(query);
    this.setState({
      companyResults: result.companies,
      searchingCompanies: false,
    });
  }, 300);

  onCompanySearch = (query: string) => {
    if (query === "") return;
    this.setState({ searchingCompanies: true });
    this.doCompanySearch(query);
  };

  selectCompany = (opt: ISelectOption | null) => {
    this.setState({ selectedOption: opt || undefined }, () =>
      this.props.onSelect(opt)
    );
  };

  render() {
    const { searchingCompanies, companyResults, selectedOption } = this.state;

    return (
      <>
        <TextFieldLabel label={"Search ConnectWise Companies"} />
        <Select
          placeholder={"Search..."}
          onInputChange={this.onCompanySearch}
          isLoading={searchingCompanies}
          options={companyResults.map(c => ({
            label: `${c.name} (${c.recid})`,
            value: c,
          }))}
          onChange={this.selectCompany}
          value={selectedOption}
        />
      </>
    );
  }
}

export default PickCwCompany;



// WEBPACK FOOTER //
// ./app/javascript/components/org/PickCwCompany.tsx